import { Map, Record } from 'immutable';
import { handleActions } from 'redux-actions';
import {
  SET_VALIDATION_VISIBILITY,
  SET_VALIDATION_BUSY,
  TOGGLE_EXPAND,
} from 'app/models/editor/constants';

const EditorState = Record({
  validationsVisible: false,
  validationBusy:     false,
  expanded:           Map(),
}, 'EditorState');

export const editor = handleActions({
  [SET_VALIDATION_VISIBILITY]: (state, { payload }) => state.set('validationsVisible', payload),
  [SET_VALIDATION_BUSY]:       (state, { payload }) => state.set('validationBusy', payload),
  [TOGGLE_EXPAND]:             (state, { payload }) => {
    const { context, defaultValue, id } = payload;
    return state.updateIn(
      ['expanded', context],
      // Prefer map to set since there may be a distinction between false and undefined.
      Map(),
      (s) => s.update(id, defaultValue, isExpanded => !isExpanded),
    );
  },
}, new EditorState());

export default editor;
